import moment from 'moment'

export default class SearchWip {

    wipTicketId: string;
    closedStartDate:  string | Date;
    closedEndDate:  string | Date;
    createdStartDate:  string | Date;
    createdEndDate:  string | Date;
    reasons: string[];
    plants: string[];
    statuses: number[];
    optionNo: string;
    materialNumber: string;
    materialDescription: string;
    salesOrderNo: string;
    releasedBy: string;
    daysOpen: number;
    limitResults: boolean;

    constructor(){
        this.wipTicketId = "";
        this.closedStartDate = "";
        this.closedEndDate = "";
        this.createdStartDate = "";
        this.createdEndDate = "";
        this.reasons = [];
        this.plants = [];
        this.statuses = [1];
        this.optionNo = "";
        this.materialNumber = "";
        this.materialDescription = "";
        this.salesOrderNo = "";
        this.releasedBy = "";
        this.daysOpen = 0;
        this.limitResults = true;
    }

}


